(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function money(cents) {
    var f = (window.JWANOU && window.JWANOU.moneyFormat) || '${{amount}}';
    var amt = (cents / 100).toFixed(2).split('.');
    amt[0] = amt[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[^}]*\}\}/, amt.join('.'));
  }

  function initDrawer() {
    var drawer = $('[data-jw-drawer]'), scrim = $('[data-jw-scrim]'), lastFocus = null;
    if (!drawer) return;
    function setOpen(open) {
      drawer.dataset.open = open ? 'true' : 'false';
      if (scrim) scrim.dataset.open = open ? 'true' : 'false';
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { lastFocus = document.activeElement; var f = drawer.querySelector('a,button'); if (f) f.focus(); }
      else if (lastFocus) { lastFocus.focus(); }
    }
    $$('[data-jw-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
    $$('[data-jw-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.dataset.open === 'true') setOpen(false); });
  }

  function initGallery() {
    $$('[data-jw-gallery]').forEach(function (gal) {
      var main = $('[data-jw-gallery-main]', gal), thumbs = $$('[data-jw-gallery-thumb]', gal);
      if (!main || !thumbs.length) return;
      var img = main.querySelector('img');
      if (img && !reduced) img.style.transition = 'opacity .28s ease';
      function show(i) {
        var t = thumbs[i]; if (!t) return;
        var im = main.querySelector('img');
        if (im) {
          var swap = function () { im.src = t.dataset.src; im.removeAttribute('srcset'); im.alt = t.dataset.alt || ''; im.style.opacity = '1'; };
          if (reduced) { swap(); } else { im.style.opacity = '0'; setTimeout(swap, 140); }
        }
        thumbs.forEach(function (o, j) { o.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); (thumbs[i + 1] || thumbs[0]).focus(); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); (thumbs[i - 1] || thumbs[thumbs.length - 1]).focus(); }
        });
      });
    });
  }

  function initQty() {
    $$('[data-jw-qty]').forEach(function (box) {
      var input = $('input', box); if (!input) return;
      $$('button', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.dataset.step === 'up' ? 1 : -1;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) input.value = 1;
      });
    });
  }

  function initRails() {
    $$('[data-jw-rail-nav]').forEach(function (nav) {
      var rail = document.getElementById(nav.dataset.jwRailNav);
      if (!rail) return;
      $$('button', nav).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = b.dataset.dir === 'next' ? 1 : -1;
          var first = rail.firstElementChild;
          var step = first ? first.getBoundingClientRect().width + 20 : 280;
          rail.scrollBy({ left: dir * step, behavior: reduced ? 'auto' : 'smooth' });
        });
      });
    });
  }

  function initSticky() {
    var sticky = $('[data-jw-sticky]'), anchor = $('[data-jw-buybox]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) { sticky.dataset.show = e[0].isIntersecting ? 'false' : 'true'; }, { rootMargin: '0px 0px -100% 0px' }).observe(anchor);
  }

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function refreshCartCount() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-jw-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
        $$('[data-jw-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
        document.dispatchEvent(new CustomEvent('jwanou:cart:updated', { detail: cart }));
        return cart;
      })
      .catch(function () {});
  }

  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-jw-add]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding\u2026'; }
      fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to bag');
          return refreshCartCount().then(function () {
            if (btn) { btn.innerHTML = 'Added \u2713'; setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1600); }
          });
        })
        .catch(function (err) {
          if (btn) { btn.innerHTML = label; btn.disabled = false; }
          var slot = form.querySelector('[data-jw-add-error]');
          if (slot) { slot.textContent = err.message; slot.hidden = false; }
        });
    });
  }

  function initReveal() {
    if (reduced || !('IntersectionObserver' in window)) {
      $$('.jw-rise').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.jw-rise').forEach(function (el) { io.observe(el); });
  }

  function boot() { initDrawer(); initGallery(); initQty(); initRails(); initSticky(); initAddToCart(); initReveal(); }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
